import React, { useCallback } from "react";

import { useIntl } from "react-intl";

import { reportsWeeklyCardAnalytics } from "@app/scene/reports/reportsAnalytics";
import WeeklyReportSetting from "@app/types/report/WeeklyReportCardSettings";

import Section from "./Section";

interface Props {
  formData: WeeklyReportSetting["value"];
  onChange?: (formData: WeeklyReportSetting["value"]) => void;
}

const ActionItems: React.FC<Props> = ({ formData, onChange }) => {
  const intl = useIntl();

  const handleToggle = useCallback(
    (enabled: boolean) => {
      onChange?.({ ...formData, actionItems: enabled });
      reportsWeeklyCardAnalytics.clicked([`Action Items Toggle ${enabled ? "On" : "Off"}`]);
    },
    [formData, onChange]
  );

  return (
    <Section
      active={formData.actionItems}
      description={intl.formatMessage({
        id: "reports.weeklyReportCard.actionItems.description",
        defaultMessage:
          "Get a rundown on the number of records past due, records that are due soon, overdue activities and scheduled activities for the week.",
        description: "Description for Action Items Section",
      })}
      disabled={!formData.enabled}
      onToggleActivation={handleToggle}
      title={intl.formatMessage({
        id: "reports.weeklyReportCard.actionItems",
        defaultMessage: "Action Items",
        description: "Title for Action Items Section",
      })}
    />
  );
};

export default ActionItems;
